<template>
	<div>
		<div class="well well-sm">
			<div class="row">
				<div class="col-sm-12">
					tarefa
					<DropDraw
						v-model="nTarefa.cod"
						:asset="assets.tarefas"
						cod="cod"
						title="tarefa"
						radio
						@input="select_tarefa"
					/>
				</div>
				<div class="col-sm-6">
					Formulário
					<DropDraw
						v-model="nTarefa.forms"
						:asset="assets.forms"
						cod="cod"
						title="titulo"
					/>
				</div>
				<div class="col-sm-6">
					Departamentos
					<DropDraw
						v-model="nTarefa.deptos"
						:asset="assets.departamentos"
						cod="cod"
						title="titulo"
					/>
				</div>
				<div class="clearfix"></div>

				<div class="col-sm-3">
					Início
					<smartTime v-model="nTarefa.iniciar" />
				</div>
				<div class="col-sm-3">
					Duração
					<smartTime v-model="nTarefa.duracao" />
				</div>
				<div class="col-sm-3">
					Recorrência
					<smartTime v-model="nTarefa.recorrencia" />
				</div>
				<div class="col-sm-3">
					<br />
					<button
						v-if="opened == null"
						class="btn btn-success btn-block"
						@click="add_tarefa"
					>
						<i class="fa fa-plus"></i>
						Adicionar
					</button>
					<button
						v-else
						class="btn btn-primary btn-block"
						@click="update_tarefa"
					>
						<i class="fa fa-save"></i>
						Alterar
					</button>
				</div>
			</div>
		</div>
		<b>Lista de tarefas</b>
		<table class="table table-striped table-bordered">
			<thead>
				<tr>
					<th>#</th>
					<th>Tarefa</th>
					<th>Departamentos</th>
					<th>Formulários</th>
					<th>Iní. / Dur. / Rec.</th>
					<th>Ações</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, id) in list">
					<td>{{ item.cod }}</td>
					<td>
						<small>{{ item.tarefa }}</small>
					</td>
					<td style="max-width: 200px">
						<span
							v-for="(depto, index) in item.deptos"
							:key="index"
							class="label label-primary"
							:title="get_text(depto)"
						>
							{{ get_text(depto) }}
						</span>
					</td>
					<td>
						<span
							v-for="(form, index) in item.forms"
							:key="index"
							class="label label-primary"
							:title="get_title(form)"
						>
							{{ get_title(form) }}
						</span>
					</td>
					<td>
						<small
							>{{ time(item.iniciar) }} /
							{{ time(item.duracao) }} /
							{{ time(item.recorrencia) }}</small
						>
					</td>
					<td>
						<button
							class="btn btn-primary btn-xs"
							@click="open_tarefa(item, id)"
						>
							<i class="fa fa-edit"></i>
						</button>
						<button
							class="btn btn-danger btn-xs"
							@click="remove_terafa(id)"
						>
							<i class="fa fa-trash"></i>
						</button>
					</td>
				</tr>
				<tr v-if="list.length == 0">
					<td colspan="5">
						<i class="fa fa-warning"></i>
						Nenhum registro encontrado!
					</td>
				</tr>
			</tbody>
		</table>
		<!-- <pre>{{list}}</pre> -->
	</div>
</template>
<script>
	import DropDraw from 'dropdraw';
	import smartTime from 'time';
	import clone from 'js/clone';
	import time from 'js/time';
	import toastr from 'toastr';

	let reset = {
		cod: '',
		deptos: [],
		iniciar: 0,
		duracao: 0,
		recorrencia: 0,
		tiptarefa: '',
		tarefa: '',
		sequencia: '',
		forms: [],
	};

	export default {
		name: 'VincTarefas',
		components: { DropDraw, smartTime },
		props: ['assets', 'dIn'],
		data() {
			return {
				nTarefa: clone(reset),
				opened: null,
			};
		},
		methods: {
			update_tarefa() {
				this.$set(this.list, this.opened, this.nTarefa);
				this.opened = null;
				this.nTarefa = clone(reset);
			},
			open_tarefa(item, id) {
				this.nTarefa = clone(item);
				this.opened = id;
			},
			remove_terafa(id) {
				this.list.splice(id, 1);
			},
			time(gtime) {
				return time(gtime);
			},
			get_text(cod) {
				let obj = this.assets.departamentos.find(
					(item) => item.cod == cod
				);
				if (obj == undefined) return '';
				return obj.titulo;
			},
			get_title(cod) {
				let obj = this.assets.forms.find((item) => item.cod == cod);
				if (obj != undefined) return obj.titulo;
				else return '???';
			},
			add_tarefa() {
				// console.log(this.nTarefa)
				if (
					this.nTarefa.tarefa != '' &&
					this.nTarefa.deptos.length > 0
				) {
					this.list.push(this.nTarefa);
					this.nTarefa = clone(reset);
				} else {
					toastr.warning(
						'É nescessário escolher uma tarefa e um departamento!'
					);
				}
			},
			select_tarefa(val) {
				let tarefa = this.assets.tarefas.find(
					(item) => item.cod == val
				);
				this.$set(this, 'nTarefa', Object.assign(this.nTarefa, tarefa));
			},
		},
		computed: {
			list() {
				return this.dIn.tarefas;
			},
		},
	};
</script>
<style scoped>
	.label {
		margin-right: 3px;
		margin-bottom: 3px;
		float: left;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/services/vincTarefas.vue